module.exports = __webpack_public_path__ + "static/media/_Logo.bed77dd1.png";